import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';
import type { MagicLoginStatus } from 'src/features/login/components/magic-login-form/magic-login-form.types';

export const magicApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMagicStatus: builder.query<ApiResponse<MagicLoginStatus>, null>({
      query: () => ({
        url: '/auth/magic',
        method: 'GET',
      }),
    }),
    sendMagicRequest: builder.mutation<ApiResponse<void>, string>({
      query: (email) => ({
        url: '/auth/magic',
        method: 'POST',
        body: { email },
      }),
    }),
  }),
});

export const { useGetMagicStatusQuery, useSendMagicRequestMutation } = magicApiSlice;
